import Backbone from "backbone";
import $ from "jquery";
import * as _ from "underscore";

import * as async from "async";
import * as modalDialog from "modalDialog";
import BookModel from "models/BookModel";
import models from "models/models";
import * as mustcache from "mustcache";
import readlangClient from "readlangClient";
import * as languageMap from "shared/languageMap";
import * as utils from "shared/utils";
import EditProfileView from "views/EditProfileView";
import PublicLibraryListView from "views/PublicLibraryListView";

let element;
let renderedCallback;
let appRouter;
let globalOptions;
let pageName = "userPage";
let initialized = false;

export const name = pageName;

const onChange = () => {
  if ($("body").attr("id") === pageName) {
    render(element, renderedCallback, appRouter, globalOptions);
  }
};

export const render = (_element, _renderedCallback, _appRouter, _options) => {
  element = _element;
  renderedCallback = _renderedCallback;
  appRouter = _appRouter;
  globalOptions = _options;

  if (!initialized) {
    models.user.on("change", onChange);
    initialized = true;
  }

  localStorage.setItem(
    "libraryOrDashboardPath",
    "/user/" + globalOptions.userID
  );

  element.empty();
  let user;
  async.series(
    [
      (callback) => {
        if (globalOptions.userID === models.user.id) {
          user = models.user.toJSON();
          callback();
        } else {
          readlangClient.request(
            "GET",
            "/api/user/" + globalOptions.userID,
            {},
            (data) => {
              user = data;
              callback();
            }
          );
        }
      },
    ],
    () => {
      if (
        user.homepageURL &&
        user.homepageURL.length > 1 &&
        !/^http:\/\/|^https:\/\//.test(user.homepageURL)
      ) {
        user.completeHomepageURL = "http://" + user.homepageURL;
      } else {
        user.completeHomepageURL = user.homepageURL;
      }

      const templateData: { [key: string]: any } = {
        user: user,
      };

      if (user._id === models.user.id) {
        templateData.editPossible = true;
      }

      if (utils.childExists(user, "googlePlusInfo.image.url")) {
        templateData.user.largeImageURL = user.googlePlusInfo.image.url.replace(
          /sz=50$/,
          "sz=120"
        );
      }
      if (utils.childExists(user, "googlePlusInfo.picture")) {
        templateData.user.largeImageURL = user.googlePlusInfo.picture;
      }
      mustcache.render("userPage", templateData, (html) => {
        element.html(html);
        const library = element.find(".sharedTexts");

        element.find("#editProfile").click(() => {
          const viewElement = $("<div/>");

          // XXX Should remove this view when closed?
          new EditProfileView({
            model: models.user,
            el: viewElement,
            finished: function () {
              modalDialog.cancel();
            },
          });
          modalDialog.show(
            $('<div class="centralDialog" />').append(viewElement)
          );
        });

        const sharedTexts = element.find(".sharedTexts");

        if (globalOptions.language) {
          const languageString =
            languageMap.map[globalOptions.language].english;

          library.append(
            "<h2>" +
              '<a href="/user/' +
              globalOptions.userID +
              '">Shared Content</a> - ' +
              languageString +
              "</h2>"
          );

          const shelvesElement = $('<div class="userPageSection"/>');
          const librarySection = $('<div class="userPageSection"/>');

          sharedTexts.append(shelvesElement);
          sharedTexts.append(librarySection);

          console.log("rendering shared content...");
          async.parallel(
            [
              (callback) => {
                renderLanguageShelves(
                  shelvesElement,
                  _.extend({ showCount: 999999 }, globalOptions),
                  callback
                );
              },
              (callback) => {
                renderLanguageBooks(
                  librarySection,
                  _.extend({ showCount: 999999 }, globalOptions),
                  callback
                );
              },
            ],
            () => {
              renderedCallback();
            }
          );
        } else {
          renderSummary(library, globalOptions, renderedCallback);
        }
      });
    }
  );
};

var renderLanguageBooks = (librarySection, options, callback?: () => void) => {
  const languageString = languageMap.map[options.language].english;

  readlangClient.request(
    "GET",
    "/api/books",
    {
      ownerID: options.userID,
      language: options.language,
      sortBy: "totalVotes",
      limit: options.showCount + 1,
    },
    (books) => {
      const booksCollection = new Backbone.Collection(
        _.map(_.first(books, options.showCount), (book) => {
          const bookModel = new BookModel(book);
          bookModel.populateExtraFields(models, true);
          return bookModel;
        }),
        { idAttribute: "_id" }
      );

      const libraryElement = $("<div/>");
      librarySection.empty();
      librarySection.append(
        '<h3 style="margin-bottom:15px">' + languageString + " Texts</h3>"
      );
      librarySection.append(libraryElement);

      // XXX Should remove this view when closed?
      new PublicLibraryListView({
        collection: booksCollection,
        models: models,
        el: libraryElement,
        // @ts-ignore
        appRouter: appRouter,
        rendered: callback,
      });
    }
  );
};

var renderLanguageShelves = (shelvesElement, options, callback) => {
  const languageString = languageMap.map[options.language].english;

  readlangClient.request(
    "GET",
    "/api/shelves",
    {
      language: options.language,
      userID: options.userID,
    },
    (shelves) => {
      if (shelves.length === 0) {
        renderedCallback();
        return;
      }

      _.each(shelves, (shelf) => {
        shelf.bookCount = shelf.books.length;
      });

      mustcache.render(
        "publicShelves",
        {
          language: options.language,
          shelves,
          languageString,
        },
        (html) => {
          shelvesElement.html(html);
          callback();
        }
      );
    }
  );
};

var renderSummary = (summaryElement, options, callback) => {
  readlangClient.request(
    "GET",
    "/api/user/" + options.userID + "/sharedBookCounts",
    {},
    (counts) => {
      _.each(counts, (languageInfo) => {
        languageInfo.languageString =
          languageMap.map[languageInfo.language].english;

        languageInfo.textPlural = languageInfo.textCount !== 1;
        languageInfo.shelfPlural = languageInfo.shelfCount !== 1;
      });

      mustcache.render(
        "userSharedCounts",
        {
          counts: counts,
          userID: options.userID,
        },
        (html) => {
          summaryElement.html(html);
          callback();
        }
      );
    }
  );
};

export const showHeader = true;
